import { Box, Table, TableBody, TableCell, TableContainer, TableRow, Link as MuiLink, IconButton } from "@mui/material";
import Gravatar from "react-gravatar";
import PasswordChangeModal from "../components/PasswordChangeModal";
import { useState } from "react";
import { Edit } from "@mui/icons-material";
import DashboardPage from "../layouts/DashboardPage";
import { Profile } from "../models";
import Link from "../components/Link";

interface ProfilePageProps {
  profile: Profile
}

export default (props: ProfilePageProps) => {
  const [isPasswordMenuOpen, setIsPasswordMenuOpen] = useState(false);
  const openPasswordModal = () => { setIsPasswordMenuOpen(true) };
  const closePasswordMenu = () => { setIsPasswordMenuOpen(false) };

  return (
    <DashboardPage title="Profile">
      <Box>
        {props.profile && (
          <TableContainer>
            <Table>
              <TableBody>
                <TableRow>
                  <TableCell component="th" scope="row">
                    Full Name
                  </TableCell>
                  <TableCell>{props.profile.fullName}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th" scope="row">
                    Email
                  </TableCell>
                  <TableCell>{props.profile.email}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th" scope="row">
                    Password
                  </TableCell>
                  <TableCell>******** <IconButton color="primary" size="small" onClick={openPasswordModal}><Edit /></IconButton></TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th" scope="row">
                    Profile Picture
                  </TableCell>
                  <TableCell>
                    <Gravatar email={props.profile.email} /><br />
                    To change your profile picture, visit <MuiLink href="https://gravatar.com" target="_blank">gravatar.com</MuiLink>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th" scope="row">
                    Discount
                  </TableCell>
                  <TableCell>
                    <Link to="/discount" style={{ textDecoration: "none" }}>Add/view current discounts</Link>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </Box>
      <PasswordChangeModal open={isPasswordMenuOpen} onClose={closePasswordMenu} />
    </DashboardPage>
  )
}
